import {
  ITonneVerschwundenCreateBody,
  ITonneVerschwundenResponseBody,
} from "../../store/slices/tonneVerschwunden";
import { adminInstance, instance } from "../api";

const getViersenTonneVerschwundenStreetsAndPlaces = () => {
  return instance
    .get<{
      places: {
        id: string;
        gemeindeBezeichnung: string;
        gemeindePostleitzahl: number;
        gemeindeNummer: number;
      }[];
      streets: {
        id: string;
        gemeindeNummer: number;
        strasseBezeichnung: string;
      }[];
    }>("tonne-verschwunden/data/viersen")
    .then((res) => res.data);
};

const getAdminTonneVerschwunden = ({
  direction,
  page,
  pageSize,
  searchValue,
  sort,
  signal,
  startDate,
  endDate,
  status,
  type,
}: {
  sort?: string;
  direction?: string;
  searchValue?: string;
  page?: number;
  pageSize?: number;
  signal: AbortSignal;
  startDate?: Date | null | string;
  endDate?: Date | null | string;
  status?: string[];
  type?: string[];
}) => {
  return adminInstance
    .get<{
      totalCount: number;
      data: ITonneVerschwundenResponseBody[];
    }>("/admin/tonne-verschwunden", {
      params: {
        direction,
        page,
        pageSize,
        searchValue,
        sort,
        startDate,
        endDate,
        status,
        type,
      },
      signal,
    })
    .then((res) => res.data);
};

const changeItemsStatuses = ({
  ids,
  status,
}: {
  ids: string[];
  status: string;
}) => {
  return adminInstance
    .put<ITonneVerschwundenResponseBody[]>(`/admin/tonne-verschwunden/status`, {
      status,
      ids,
    })
    .then((res) => res.data);
};

const getAdminTonneVerschwundenItemById = (id: string) => {
  return adminInstance
    .get<ITonneVerschwundenResponseBody>(`/admin/tonne-verschwunden/${id}`)
    .then((res) => res.data);
};

const updateStatusById = ({
  id,
  status,
  message,
  calenderWeek,
  updatedStatusType,
}: {
  id: string;
  status: string;
  message?: string;
  calenderWeek?: string;
  updatedStatusType?: string;
}) => {
  return adminInstance
    .put<ITonneVerschwundenResponseBody>(
      `/admin/tonne-verschwunden/${id}/status`,
      {
        status,
        message,
        calenderWeek,
        updatedStatusType,
      },
    )
    .then((res) => res.data);
};

const checkMultipleTonneVerschwundenOnObject = ({
  fraction,
  place,
  street,
  volume,
  homeNumber,
  hausNrZusatz,
  signal,
  homeNumberInfo,
}: {
  fraction: string;
  volume: string;
  place: string;
  street: string;
  homeNumber: string;
  hausNrZusatz?: string;
  signal: AbortSignal;
  homeNumberInfo?: string | null;
}) => {
  return instance
    .get<{
      hasMultipleTonnen: boolean;
      totalQuantity: number;
    }>("tonne-verschwunden/check-tonnen", {
      params: {
        fraction,
        place,
        street,
        homeNumber,
        volume,
        hausNrZusatz,
        homeNumberInfo,
      },
      signal,
    })
    .then((res) => res.data);
};

const createTonneVerschwunden = (data: ITonneVerschwundenCreateBody) => {
  return instance
    .post<{
      error?: boolean;
      errorMessage?: string;
    }>("/tonne-verschwunden", data)
    .then((res) => res.data);
};

const getTonnenVolumes = ({
  color,
  homeNumber,
  place,
  street,
  hausNrZusatz,
  homeNumberInfo,
}: {
  color: string;
  place: string;
  street: string;
  homeNumber: string;
  hausNrZusatz?: string;
  homeNumberInfo?: string | null;
}) => {
  return instance.get<{
    data: number[];
  }>(`tonne-verschwunden/tonnen-volumen`, {
    params: {
      color,
      homeNumber,
      place,
      street,
      hausNrZusatz,
      homeNumberInfo,
    },
  });
};

const TonneVerschwunden = {
  get: {
    getViersenTonneVerschwundenStreetsAndPlaces,
    getAdminTonneVerschwunden,
    getAdminTonneVerschwundenItemById,
    checkMultipleTonneVerschwundenOnObject,
    getTonnenVolumes,
  },
  post: {
    createTonneVerschwunden,
  },
  put: {
    changeItemsStatuses,
    updateStatusById,
  },
};

export default TonneVerschwunden;
